module.exports = __webpack_public_path__ + "img/sandbox-evaluation-pending.332319eb.svg";